import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	headingContainer: {
		width: 'fit-content',
		marginLeft: '5rem',
		marginTop: '4rem'
	},
	pagePath: {
		color: theme.palette.primary.grey
	},
	headingName: {
		fontWeight: '600',
		color: 'black',
		textAlign: 'center',
		width: 'fit-content',
		marginTop: '.5rem !important'
	},
	description: {
		paddingLeft: '.3rem',
		marginTop: '1rem !important'
	}
}));
